import React from "react";
import { FaBolt, FaShieldAlt, FaHandHoldingUsd } from "react-icons/fa";

const PriorityStatus: React.FC = () => {
  return (
    <section className="w-full py-20 bg-transparent relative overflow-hidden">
      {/* Subtle light spill background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-b from-blue-50/20 to-transparent -z-10" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        {[
          { 
            label: "Secured Data System", 
            icon: <FaShieldAlt />, 
            value: "Protected",
            glow: "rgba(26, 47, 90, 0.2)"
          },
          { 
            label: "Customized Loan Options", 
            icon: <FaHandHoldingUsd />, 
            value: "Flexible",
            glow: "rgba(212, 165, 74, 0.2)"
          },
          { 
            label: "Instant Approval Process", 
            icon: <FaBolt />, 
            value: "Efficient",
            glow: "rgba(26, 47, 90, 0.2)"
          }
        ].map((item, i) => (
          <div 
            key={i} 
            className="group flex items-center gap-6 p-8 glass-morphism border border-white/50 rounded-[2.5rem] shadow-xl hover:shadow-shadow-2x-strong transition-all duration-500 hover:-translate-y-2"
          >
            <div 
              className="w-16 h-16 rounded-2xl bg-white flex items-center justify-center text-3xl text-primary shadow-lg group-hover:scale-110 transition-transform duration-500"
              style={{ boxShadow: `0 10px 20px -5px ${item.glow}` }}
            >
              {item.icon}
            </div>
            <div>
              <div className="text-[10px] font-black text-secondary uppercase tracking-[0.2em] mb-1 opacity-80 group-hover:opacity-100 transition-opacity">
                {item.value}
              </div>
              <div className="text-lg font-black text-text-primary leading-tight tracking-tight">
                {item.label}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PriorityStatus;
